import { render, staticRenderFns } from "./ContactWe.vue?vue&type=template&id=051ef6a6&scoped=true&"
import script from "./ContactWe.vue?vue&type=script&lang=js&"
export * from "./ContactWe.vue?vue&type=script&lang=js&"
import style0 from "./ContactWe.vue?vue&type=style&index=0&id=051ef6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ef6a6",
  null
  
)

export default component.exports